/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-05-11 10:52:12
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 管控参数
 * @FilePath     : /src/views/platform/ICPS/internetSales/supplyManagement/controlSet/supplyControlSet.vue
 */
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <el-button style="margin-left: 24px" size="medium" class="bottom_all" @click="add()">添加公司</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '操作'">
                        <el-link :underline="false" type="success" @click="openControlSet(scope.row)">
                          参数设置
                        </el-link>
                        <el-link :underline="false" type="danger" style="margin-left: 12px"
                          @click="deleteData(scope.row)">
                          删除
                        </el-link>
                      </span>
                      <span v-else-if="item.label == '是否风控'">
                        <el-switch v-model="scope.row.enable" active-color="#13ce66" inactive-color="#ff4949"
                          :active-value="1" :inactive-value="0" @change="changeEnable((e) => e, scope.row)">
                        </el-switch>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <!-- <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination> -->
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>

      <!-- 添加公司 -->
      <el-dialog :visible.sync="addCompanyDig" width="980px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">添加公司</span>
        <el-row class="textCss">
          <el-col :span="2" :offset="2" style="text-aligin: center">
            <span>公司:</span>
          </el-col>
          <el-col :span="12">
            <el-select ref="select" v-model="companyForm.companyId" placeholder="请选择" @change="
              $nextTick(() => {
                companyForm.companyName = $refs.select.selectedLabel;
              })
              ">
              <el-option v-for="(item, index) in companylist" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="textCss" style="margin-top: 24px">
          <el-col :span="2" :offset="2" style="text-aligin: center">
            <span>类型:</span>
          </el-col>
          <el-col :span="12">
            <el-select ref="controlTypeVal" v-model="companyForm.controlTypeVal" placeholder="请选择" @change="
              $nextTick(() => {
                companyForm.controlTypeName = $refs.controlTypeVal.selectedLabel;
              })
              ">
              <el-option v-for="(item, index) in controlTypeList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 24px">
          <el-col :span="2" :offset="2">
            <span>是否风控:</span>
          </el-col>
          <el-col :span="12" :offset="2">
            <el-switch v-model="companyForm.enable" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="addCompanyDig = false">关 闭</el-button>
          <el-button class="bottom_all" @click="saveCompany">保 存</el-button>
        </span>
      </el-dialog>
      <debetControl :debetControlDig.sync="debetControlDig" :low="low" @closeDig="debetControlDig = false" />
      <processDiffer :processDifferDig.sync="processDifferDig" :low="low" @closeDig="processDifferDig = false" />
      <superGraph  :superGraphDig.sync="superGraphDig" :low="low" @closeDig="superGraphDig = false" />
      <delegatedControl  :delegatedControlDig.sync="delegatedControlDig" :low="low" @closeDig="delegatedControlDig = false" />
      <exceedContract :exceedContractDig.sync="exceedContractDig" :low="low" @closeDig="exceedContractDig = false" />
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryControl,
  addCompanyControl,
  updateCompanyControl,
} from "@/api/internetSales/supplyManagement.js";
import { permissionsCompanyList } from "@/api/common.js";
import debetControl from "./components/debetControl.vue";
import processDiffer from "./components/processDiffer.vue";
import superGraph from "./components/superGraph.vue";
import delegatedControl from "./components/delegatedControl.vue";
import exceedContract from "./components/exceedContract.vue";
export default {
  components: {
    debetControl,
    processDiffer,
    superGraph,
    delegatedControl,
    exceedContract,
  },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "公司", prop: "companyName", status: true, width: "auto" },
        { label: "类型", prop: "controlTypeName", status: true, width: "auto" },
        { label: "是否风控", prop: "enable", status: true, width: "auto" },
        { label: "操作", prop: "approvalStatus", status: true, width: "auto" },
      ],
      tableData: [],
      pagesType: 0,
      tableParam: {
        page: 1,
        pageSize: 10,
        dataMouth: "", //筛选条件：时间
      },
      debetControlDig: false,
      processDifferDig:false,
      superGraphDig:false,
      delegatedControlDig:false,
      exceedContractDig:false,
      controlTypeList: [
        {
          name: "项目回款-欠款管控",
          id: 1,
        },
        {
          name: "合同履约-过程量差流程控制",
          id: 2,
        },
        {
          name: "合同履约-超图算管控",
          id: 3,
        },
        {
          name: "合同履约-超合同供应",
          id: 4,
        },
        {
          name: "前期委托-委托供应管控",
          id: 5,
        },
        {
          name: "项目结算",
          id: 6,
        },
      ],
      companylist: [],
      addCompanyDig: false,
      companyForm: {
        enable: 1, //启用禁用：0禁用；1启用
        companyId: "",
        companyName: "",
        controlTypeVal: "",
        controlTypeName: "",
      },
      low: {},
    };
  },
  watch: {},
  async created() {
    this.gettableData();
    this.companylist = await permissionsCompanyList();
  },
  methods: {
    openControlSet(row) {
      this.debetControlDig = false;
      this.processDifferDig = false;
      this.superGraphDig = false;
      this.delegatedControlDig = false;
      this.exceedContractDig = false;
      this.$nextTick(() => {
        this.low = JSON.parse(JSON.stringify(row));
        // 1欠款供应 2过程量差 3超图算 4超合同供应 5委托供应 6项目结算
        if (row.controlTypeVal == 1) {
          this.debetControlDig = true;
        } else if (row.controlTypeVal == 2) {
          this.processDifferDig = true;
        } else if (row.controlTypeVal == 3) {
          this.superGraphDig = true;
        } else if (row.controlTypeVal == 4) {
          this.exceedContractDig = true;
        } else if (row.controlTypeVal == 5) {
          this.delegatedControlDig = true;
        } else if (row.controlTypeVal == 6) {
           this.$message.warning('该类型暂未配置弹窗');
        }
      });
    },
    deleteData(row) {
      this.$confirm("是否删除该公司数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        updateCompanyControl({ id: row.id, status: 0 }).then((res) => {
          if (res.code == 1001) {
            this.$message.success("删除成功!");
            this.gettableData();
          }
        });
      });
    },
    changeEnable(enable, row) {
      updateCompanyControl({ id: row.id, enable: row.enable }).then((res) => {
        if (res.code == 1001) {
          this.$message.success("修改成功!");
        }
      });
    },
    saveCompany() {
      if (!this.companyForm.companyId) {
        this.$message.warning("请选择公司!");
        return;
      }
      addCompanyControl(this.companyForm).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.gettableData();
          this.addCompanyDig = false;
        }
      });
    },
    add() {
      this.companyForm = this.$options.data().companyForm;
      this.addCompanyDig = true;
    },
    gettableData() {
      queryControl().then((res) => {
        if (res.code == 1001) {
          this.tableData = res.data;
          this.total = res.data.length;
        }
      });
    },
    lookDetail(row) {
      this.$router.push({
        name: "overdueSupplyReviewDetail",
        query: { id: row.id, approvalStatus: row.approvalStatus },
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = this.$options.data().tableParam;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}

.textCss {
  display: flex;
  align-items: center;
}
</style>
